import { ALL_VALUE } from './helper';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';

export const reasonDefault: DropdownOption = {
  key: ALL_VALUE,
  value: ALL_VALUE,
  label: 'All reasons',
};
export const SCENARIO_IDS_PARAM = 'scenarioIds';

export const multiReasonsSelectedOrURLOrDefault = (
  allReasons: DropdownOption[],
  selectedReasons: DropdownOption[] | undefined
) => {
  if (selectedReasons !== undefined) {
    return selectedReasons;
  }

  const params = new URLSearchParams(location.search);
  const value = params.get(SCENARIO_IDS_PARAM);
  if (value !== null) {
    const idsFromParams = value.split(',');
    const reasonsInsideAllReasons = allReasons.filter((r) => {
      return r.value.split(',').some((id) => idsFromParams.includes(id));
    });

    if (reasonsInsideAllReasons.length > 0) return reasonsInsideAllReasons;
  }

  return [reasonDefault];
};

export const reasonIdsToFetchForTransactionAlertsBacklog = (
  allReasons: DropdownOption[],
  selectedReasons: DropdownOption[] | undefined
) => {
  const reasons = multiReasonsSelectedOrURLOrDefault(allReasons, selectedReasons);
  return joinScenarioIds(reasons);
};

export const joinScenarioIds = (selectedMultiReason: Array<DropdownOption> | undefined): string | undefined => {
  if (selectedMultiReason === undefined) return undefined;

  const ids = selectedMultiReason
    .filter((so) => so.value !== ALL_VALUE)
    .map((so) => so.value)
    .join();
  if (ids.length === 0) return undefined;
  return ids;
};
